/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-classes-per-file */
export class PaperworkFieldTypes {
  static ADDRESS = 'address';

  static BIRTH_DATE = 'birth_date';

  static EMAIL = 'email';

  static INPUT = 'input';

  static PHONE_NUMBER = 'phone';

  static RELATIONSHIP_TO_ACCOUNT = 'relationship_to_account';

  static SELECT = 'select';

  static SOCIAL_SECURITY_NUMBER = 'ssn';

  static PHARMACY_SEARCH = 'pharmacy_search';

  static CHECK_BOX = 'check_box';
}

export class PaperworkSectionRoutes {
  static START = '/paperwork/start';

  static PATIENT = '/paperwork/patient';

  static EMPLOYER = '/paperwork/employer';

  static PAYMENT = '/paperwork/payment';

  static GUARDIAN = '/paperwork/guardian';

  static EMERGENCY_CONTACT = '/paperwork/emergency-contact';

  static CUSTOM = '/paperwork/custom';

  static CONSENT = '/paperwork/consent';

  static FINALIZE = '/paperwork/finalize';

  static COMPLETE = '/paperwork/complete';
}

// type: enum of non-negative integer
// description: the current page we're on for paperwork sections with multiple pages
export class PaperworkCurrentSectionPageView {
  static ONE = 0;

  static TWO = 1;

  static THREE = 2;
}

export class PaperworkStatuses {
  static COMPLETE = 'complete';

  static IN_PROGRESS = 'in_progress';
}

export class EmployerRelatedVisitReason {
  static PHYSICAL = 'Physical';

  static DRUG_SCREEN_ALCOHOL_TEST = 'Drug Screen and/or Alcohol Test';

  static WORK_INJURY = 'Work Injury';
}
export const REGISTRATION_PAPERWORK = 'registration';
export const LOCATION_PAPERWORK_RESPONSE_TYPE_REGISTRATION = 'registration';

export const PAPERWORK_FIELD_ANSWER_YES = 'Yes';
export const PAPERWORK_FIELD_ANSWER_NO = 'No';

export class PaperworkFieldNames {
  static PATIENT_FIELD_FIRST_NAME = 'patientFirstName';

  static PATIENT_FIELD_MIDDLE_NAME = 'patientMiddleName';

  static PATIENT_FIELD_LAST_NAME = 'patientLastName';

  static PATIENT_FIELD_BIRTH_DATE = 'birthDate';

  static PATIENT_FIELD_GENDER = 'patientGender';

  static PATIENT_FIELD_BIRTH_SEX = 'patientBirthSex';

  static PATIENT_FIELD_ETHNICITY = 'ethnicity';

  static PATIENT_FIELD_RACE = 'race';

  static PATIENT_ADDRESS_STREET = 'patientAddressStreet';

  static PATIENT_ADDRESS_STREET_TWO = 'patientAddressStreetTwo';

  static PATIENT_ADDRESS_CITY = 'patientAddressCity';

  static PATIENT_ADDRESS_STATE = 'patientAddressState';

  static PATIENT_ADDRESS_ZIP = 'patientAddressZip';

  static PATIENT_PRIMARY_PHONE = 'primaryPhone';

  static PATIENT_EMAIL = 'email';

  static PATIENT_MARITAL_STATUS = 'maritalStatus';

  static PATIENT_SOCIAL_SECURITY_NUMBER = 'ssn';

  static REASON_FOR_VISIT = 'reasonForVisit';

  static PRIMARY_CARE_PHYSICIAN = 'physician';

  static PREFERRED_PHARMACY = 'pharmacy';

  static HOW_DID_YOU_HEAR_ABOUT_US = 'howHearAboutUs';

  static EMPLOYER = 'employer';

  static EMPLOYER_CONTACT_NAME = 'workInjuryEmployerContactName';

  static EMPLOYER_CONTACT_PHONE = 'workInjuryEmployerContactPhoneNumber';

  static CUSTOM_EMPLOYER = 'customEmployer';

  static WHAT_ARE_YOU_HERE_FOR = 'whatAreYouHereFor';

  static WHAT_TYPE_OF_PHYSICAL = 'whatTypeOfPhysical';

  static WHAT_TYPE_OF_DRUG_SCREEN_OR_ALCOHOL_TEST = 'whatTypeOfDrugScreenAlcoholTest';

  static HOW_DID_YOUR_INJURY_OCCUR = 'howDidYourInjuryOccur';

  static WHEN_DID_YOUR_INJURY_OCCUR = 'whenDidYourInjuryOccur';

  static TO_WHOM_REPORTED_YOUR_INJURY = 'toWhomReportedYourInjury';

  static WHERE_WAS_PRIOR_TREATMENT = 'whereWasPriorTreatment';

  static TREATED_AT_THE_REQUEST_OF_EMPLOYER = 'areYouBeingTreatedAtTheRequestOfYourEmployer';

  static SELF_PAY_CHECK = 'selfPayCheck';

  static PRIMARY_INSURANCE_COMPANY = 'insuranceCompany' as const;

  static PRIMARY_INSURANCE_PLAN_NAME = 'insurancePlanName' as const;

  static PRIMARY_MEMBER_ID = 'memberId';

  static PRIMARY_GROUP_NUMBER = 'groupNumber';

  static PRIMARY_POLICY_HOLDER_FIRST_NAME = 'policyHolderFirstName';

  static PRIMARY_POLICY_HOLDER_MIDDLE_NAME = 'policyHolderMiddleName';

  static PRIMARY_POLICY_HOLDER_LAST_NAME = 'policyHolderLastName';

  static PRIMARY_POLICY_HOLDER_BIRTH_DATE = 'policyHolderBirthDate';

  static PRIMARY_POLICY_HOLDER_BIRTH_SEX = 'policyHolderBirthSex';

  static PATIENTS_RELATIONSHIP_TO_INSURED = 'patientsRelationshipToInsured';

  static DO_YOU_HAVE_SECONDARY_INSURANCE_INFORMATION = 'doYouHaveSecondInsuranceInformation';

  static SECONDARY_INSURANCE_COMPANY = 'secondaryInsuranceCompany';

  static SECONDARY_INSURANCE_PLAN_NAME = 'secondaryInsurancePlanName';

  static SECONDARY_MEMBER_ID = 'secondaryMemberId';

  static SECONDARY_GROUP_NUMBER = 'secondaryGroupNumber';

  static SECONDARY_POLICY_HOLDER_FIRST_NAME = 'secondaryPolicyHolderFirstName';

  static SECONDARY_POLICY_HOLDER_MIDDLE_NAME = 'secondaryPolicyHolderMiddleName';

  static SECONDARY_POLICY_HOLDER_LAST_NAME = 'secondaryPolicyHolderLastName';

  static SECONDARY_POLICY_HOLDER_BIRTH_DATE = 'secondaryPolicyHolderBirthDate';

  static SECONDARY_PATIENTS_RELATIONSHIP_TO_INSURED = 'secondaryPatientsRelationshipToInsured';

  static GUARDIAN_FIRST_NAME = 'guardianFirstName';

  static GUARDIAN_MIDDLE_NAME = 'guardianMiddleName';

  static GUARDIAN_LAST_NAME = 'guardianLastName';

  static GUARDIAN_BIRTH_DATE = 'guardianBirthDate';

  static GUARDIAN_RELATIONSHIP_TO_PATIENT = 'relationshipToPatient';

  static GUARDIAN_ADDRESS = 'guardianAddress';

  static GUARDIAN_PHONE = 'guardianPhone';

  static GUARDIAN_ALTERNATE_PHONE = 'altGuardianPhone';

  static GUARDIAN_EMAIL = 'guardianEmail';

  static EMERGENCY_CONTACT_FIRST_NAME = 'emergencyContactFirstName';

  static EMERGENCY_CONTACT_MIDDLE_NAME = 'emergencyContactMiddleName';

  static EMERGENCY_CONTACT_LAST_NAME = 'emergencyContactLastName';

  static EMERGENCY_CONTACT_PHONE = 'emergencyContactPhone';

  static EMERGENCY_CONTACT_RELATIONSHIP_TO_PATIENT = 'emergencyContactRelationshipToPatient';
}

// Maps to the validation rules here: https://github.com/yiminghe/async-validator
export const PAPERWORK_FIELD_VALIDATIONS: Record<string, Array<{ [key: string]: any }>> = {
  [PaperworkFieldNames.PATIENT_ADDRESS_ZIP]: [
    {
      len: 5,
      message: 'Zip code must be exactly 5 characters.',
    },
  ],
};

export const PAPERWORK_FIELD_INPUT_ADDITIONAL_PROPS: Record<string, Record<string, any>> = {
  [PaperworkFieldNames.PATIENT_ADDRESS_ZIP]: {
    maxLength: 5,
  },
};

export const PATIENT_FORM_PAGE_ONE_FIELD_NAMES = [
  PaperworkFieldNames.PATIENT_FIELD_FIRST_NAME,
  PaperworkFieldNames.PATIENT_FIELD_MIDDLE_NAME,
  PaperworkFieldNames.PATIENT_FIELD_LAST_NAME,
  PaperworkFieldNames.PATIENT_FIELD_BIRTH_DATE,
  PaperworkFieldNames.PATIENT_FIELD_GENDER,
  PaperworkFieldNames.PATIENT_FIELD_BIRTH_SEX,
  PaperworkFieldNames.PATIENT_FIELD_ETHNICITY,
  PaperworkFieldNames.PATIENT_FIELD_RACE,
  PaperworkFieldNames.PATIENT_MARITAL_STATUS,
  PaperworkFieldNames.PATIENT_SOCIAL_SECURITY_NUMBER,
];

export const PATIENT_FORM_PAGE_TWO_FIELD_NAMES = [
  PaperworkFieldNames.PATIENT_ADDRESS_STREET,
  PaperworkFieldNames.PATIENT_ADDRESS_STREET_TWO,
  PaperworkFieldNames.PATIENT_ADDRESS_CITY,
  PaperworkFieldNames.PATIENT_ADDRESS_STATE,
  PaperworkFieldNames.PATIENT_ADDRESS_ZIP,
  PaperworkFieldNames.PATIENT_PRIMARY_PHONE,
  PaperworkFieldNames.PATIENT_EMAIL,
];

export const PATIENT_FORM_PAGE_THREE_FIELD_NAMES = [
  PaperworkFieldNames.REASON_FOR_VISIT,
  PaperworkFieldNames.PRIMARY_CARE_PHYSICIAN,
  PaperworkFieldNames.PREFERRED_PHARMACY,
  PaperworkFieldNames.HOW_DID_YOU_HEAR_ABOUT_US,
];

export const EMPLOYER_RELATED_FIELD_NAMES = [
  PaperworkFieldNames.EMPLOYER,
  PaperworkFieldNames.EMPLOYER_CONTACT_NAME,
  PaperworkFieldNames.EMPLOYER_CONTACT_PHONE,
  PaperworkFieldNames.WHAT_ARE_YOU_HERE_FOR,
];

export const CUSTOM_EMPLOYER_RELATED_FIELD_NAMES = [
  PaperworkFieldNames.CUSTOM_EMPLOYER,
  ...EMPLOYER_RELATED_FIELD_NAMES.slice(1),
];

export const WORK_RELATED_INJURY_FIELD_NAMES = [
  PaperworkFieldNames.HOW_DID_YOUR_INJURY_OCCUR,
  PaperworkFieldNames.WHEN_DID_YOUR_INJURY_OCCUR,
  PaperworkFieldNames.TO_WHOM_REPORTED_YOUR_INJURY,
  PaperworkFieldNames.WHERE_WAS_PRIOR_TREATMENT,
];

export const EMPLOYER_FORM_FIELD_NAMES = [
  PaperworkFieldNames.TREATED_AT_THE_REQUEST_OF_EMPLOYER,
  ...EMPLOYER_RELATED_FIELD_NAMES,
  PaperworkFieldNames.WHAT_TYPE_OF_PHYSICAL,
  PaperworkFieldNames.WHAT_TYPE_OF_DRUG_SCREEN_OR_ALCOHOL_TEST,
  ...WORK_RELATED_INJURY_FIELD_NAMES,
];

export const PAYMENT_FORM_FIELD_NAMES = [
  PaperworkFieldNames.SELF_PAY_CHECK,
  PaperworkFieldNames.PRIMARY_INSURANCE_COMPANY,
  PaperworkFieldNames.PRIMARY_INSURANCE_PLAN_NAME,
  PaperworkFieldNames.PRIMARY_MEMBER_ID,
  PaperworkFieldNames.PRIMARY_GROUP_NUMBER,
  PaperworkFieldNames.PRIMARY_POLICY_HOLDER_FIRST_NAME,
  PaperworkFieldNames.PRIMARY_POLICY_HOLDER_MIDDLE_NAME,
  PaperworkFieldNames.PRIMARY_POLICY_HOLDER_LAST_NAME,
  PaperworkFieldNames.PRIMARY_POLICY_HOLDER_BIRTH_SEX,
  PaperworkFieldNames.PRIMARY_POLICY_HOLDER_BIRTH_DATE,
  PaperworkFieldNames.PATIENTS_RELATIONSHIP_TO_INSURED,
];

export const SECONDARY_PAYMENT_FORM_FIELD_NAMES = [
  PaperworkFieldNames.SECONDARY_INSURANCE_COMPANY,
  PaperworkFieldNames.SECONDARY_INSURANCE_PLAN_NAME,
  PaperworkFieldNames.SECONDARY_MEMBER_ID,
  PaperworkFieldNames.SECONDARY_GROUP_NUMBER,
  PaperworkFieldNames.SECONDARY_POLICY_HOLDER_FIRST_NAME,
  PaperworkFieldNames.SECONDARY_POLICY_HOLDER_MIDDLE_NAME,
  PaperworkFieldNames.SECONDARY_POLICY_HOLDER_LAST_NAME,
  PaperworkFieldNames.SECONDARY_POLICY_HOLDER_BIRTH_DATE,
  PaperworkFieldNames.SECONDARY_PATIENTS_RELATIONSHIP_TO_INSURED,
];

export const GUARDIAN_FORM_FIELD_NAMES = [
  PaperworkFieldNames.GUARDIAN_FIRST_NAME,
  PaperworkFieldNames.GUARDIAN_MIDDLE_NAME,
  PaperworkFieldNames.GUARDIAN_LAST_NAME,
  PaperworkFieldNames.GUARDIAN_BIRTH_DATE,
  PaperworkFieldNames.GUARDIAN_RELATIONSHIP_TO_PATIENT,
  PaperworkFieldNames.GUARDIAN_ADDRESS,
  PaperworkFieldNames.GUARDIAN_PHONE,
  PaperworkFieldNames.GUARDIAN_ALTERNATE_PHONE,
  PaperworkFieldNames.GUARDIAN_EMAIL,
];

export const EMERGENCY_CONTACT_FIELD_NAMES = [
  PaperworkFieldNames.EMERGENCY_CONTACT_FIRST_NAME,
  PaperworkFieldNames.EMERGENCY_CONTACT_MIDDLE_NAME,
  PaperworkFieldNames.EMERGENCY_CONTACT_LAST_NAME,
  PaperworkFieldNames.EMERGENCY_CONTACT_PHONE,
  PaperworkFieldNames.EMERGENCY_CONTACT_RELATIONSHIP_TO_PATIENT,
];

export class PAPERWORK_FORM_NAMES {
  static PATIENT = 'patient';

  static EMPLOYER = 'employer';

  static INSURANCE = 'insurance';

  static GUARDIAN = 'guardian';

  static EMERGENCY_CONTACT = 'emergency_contact';

  static ADDITIONAL = 'additional';

  static CONSENT = 'consent';

  static REVIEW = 'review';
}
